import { axiosInstance } from "../axiosUtil";

import getAuthHeader from "../Auth/GetAuthHeader";

class FieldChoiceService {
  getFieldChoices(accountId, fieldId) {
    const headers = {
      Authorization: getAuthHeader(),
    };

    return axiosInstance
      .get(`/api/v1/account/${accountId}/field_choices/${fieldId}`, { headers })
      .then((response) => {
        return response.data;
      });
  }
}

export default new FieldChoiceService();
